import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { NewIcon } from '../../../../components/newIcon/icon';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer } from '../heroSection/heroSection.styled';
import {
  ProcessesContainer,
  SignUpProcessContent,
  CallToActionContainer,
  CallToActionTextContainer,
} from './callToAction.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

export function CallToAction() {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <CallToActionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-lady-walking-dog.png`}
        alt="Lady walking a dog"
        height={3000}
        width={3000}
      />
      <WidthContainer noBackground>
        <CallToActionTextContainer>
          <SignUpProcessContent>
            <ProcessesContainer>
              <NewIcon type="PataLogo" />
              <h2>
                <TextWithHighlight>
                  <div>Join other pet care professionals using Pata booking software to manage bookings with ease</div>
                </TextWithHighlight>
              </h2>
              <p>
                From new businesses to fully booked salons, Pata helps you stay organised, reduce admin and minimise
                late cancellations — all in one booking platform
              </p>
              <ActionContainer>
                <Button onClick={handleSignUpClick}>Sign up today</Button>
                <Button buttonType="secondary" onClick={handleBookDemo}>
                  Book a demo
                </Button>
              </ActionContainer>
            </ProcessesContainer>
          </SignUpProcessContent>
        </CallToActionTextContainer>
      </WidthContainer>
    </CallToActionContainer>
  );
}
